//values

//ready
jQuery(document).ready(function () {

  //values
	let ua = window.navigator.userAgent;
	let ios = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
	let webkit = !!ua.match(/WebKit/i);
	let iossafari = ios && webkit && !ua.match(/CriOS/i);
	
	//if
	if(iossafari === true) {

		//add
		jQuery('body').addClass('software-iossafari');
		
	}

	jQuery('#nav-icon1').click(function(){
		jQuery(this).toggleClass('open');
    jQuery(".menu-dwn-wrap").toggleClass('active');
	});
	
	jQuery('.lchtbtn').on('click', function() {
		jQuery('.livesdk__invitation').click();
	});
  
});

//functions
let serialize_form = function(form) {

  //values
	var obj = {};
	var formData = new FormData(form);

  //for
	for (var key of formData.keys()) {

    //set
		obj[key] = formData.get(key);
    
	}

  //return
	return obj;

}
